import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import OccupancyRateCard from "./OccupancyRateCard";
import NoDataFound from "../../../components/common/NoDataFound";
import { useTranslation } from "react-i18next";
import DateRangePicker from "../../../components/common/DateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import { getMinMaxDate } from "components/common/Utils";
import { getOverviewDashboardSpaceDetails } from "store/actions/dashboardSlice";
import { MultiSelect } from "primereact/multiselect";
import { orderSpaceType } from "components/constants/DropdownOptions";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { Dropdown } from "primereact/dropdown";
import { orderByOptions } from "components/constants/StatusKeys";
import { addMonths, startOfDay, subMonths } from "date-fns";

const OccupancyAndSales = () => {
  const { t } = useTranslation();
  const { loading2, overviewDashboardSpaceDetails } = useSelector(
    (state) => state.Dashboards
  );

  const dispatch = useDispatch();
  const today = startOfDay(new Date());
  const oneMonthBefore = startOfDay(subMonths(today, 1));
  const defaultDates = [oneMonthBefore, today];
  const [dates, setDates] = useState(defaultDates);
  const [spaceTypes, setSpaceTypes] = useState([]);
  const [sortBy, setSortBy] = useState("occupancyRate");
  const [orderBy, setOrderBy] = useState(-1);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const isReset = actionType === "RESET";

    const payload = {
      spaceTypeInt: isReset ? [] : spaceTypes, // [] for all , 1 - workspace, 2- meetingroom, 3 - workshop
      branches: [],
      dateRange: isReset ? getMinMaxDate(defaultDates) : getMinMaxDate(dates),
      sortBy: isReset ? "occupancyRate" : sortBy,
      orderBy: isReset ? -1 : orderBy,
    };
    dispatch(getOverviewDashboardSpaceDetails(payload));
  };

  const handleReset = () => {
    setDates(defaultDates);
    setSpaceTypes([]);
    setSortBy("occupancyRate");
    setOrderBy(-1);
    getAllData({ actionType: "RESET" });
  };

  const sortByOptions = [
    { name: "Total Sales", value: "totalRevenue" },
    { name: "Occupancy Rate", value: "occupancyRate" },
    // { name: "Total Bookings", value: "totalBookings" },
  ];

  return (
    <div className="total_sale_row">
      <div className="g_between gap-3 mb-4 flex-wrap">
        <h2 className="fs_20">{t("Occupancy Rate and Total Sales")}</h2>
        <div className="d-flex gap-3 common_filter mb-0 flex-wrap">
          <div className="buttons">
            <button
              className="search_btn"
              onClick={() => getAllData({ actionType: "SEARCH" })}
            >
              {t("Apply")}
            </button>
            <button className="reset_btn" onClick={handleReset}>
              {t("Reset")}
            </button>
          </div>
          <Dropdown
            value={sortBy}
            onChange={(e) => {
              setSortBy(e.value);
            }}
            options={sortByOptions}
            optionLabel="name"
            placeholder={t("Sort By")}
            className="custom_dropdown"
          />
          <Dropdown
            value={orderBy}
            onChange={(e) => {
              setOrderBy(e.value);
            }}
            options={orderByOptions}
            optionLabel="name"
            placeholder={t("Order By")}
            className="custom_dropdown"
          />
          <MultiSelect
            value={spaceTypes}
            onChange={(e) => setSpaceTypes(e.value)}
            options={orderSpaceType}
            selectAllLabel={t("Select All")}
            optionLabel="name"
            placeholder={"Space Type"}
            maxSelectedLabels={3}
            className="filter_multi_select"
          />
          <DateRangePicker dates={dates} setDates={setDates} />
        </div>
      </div>
      <Row>
        {loading2 ? (
          <ShimmerThumbnail height={446} className="m-0" rounded />
        ) : overviewDashboardSpaceDetails.length > 0 ? (
          overviewDashboardSpaceDetails?.map((occupancy, index) => (
            <OccupancyRateCard
              key={occupancy?.id}
              occupancy={occupancy}
              index={index}
            />
          ))
        ) : (
          <NoDataFound />
        )}
      </Row>
    </div>
  );
};

export default OccupancyAndSales;
